export default "__VITE_ASSET__CF_QZ3Xn__"